/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */

/**
 * Shared constants and helpers for the Doctor Command Center and its
 * extracted sub-components (Phase: Code Quality refactor).
 */

export const DAYS = ['Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab', 'Dom'];

export const URGENCY_META = {
  routine: { cls: 'badge-online', label: 'urgencyRoutine' },
  urgent: { cls: 'badge-waiting', label: 'urgencyUrgent' },
  emergency: { cls: 'badge-emergency', label: 'urgencyEmergency' },
};

export const dayLabel = (d, locale = 'it') =>
  d.toLocaleDateString(locale, { weekday: 'long', day: 'numeric', month: 'long' });

export const startOfDay = (d) => {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
};
